import { Injectable } from "@angular/core";
import { HttpService } from "./utils/services/http.service";
import { Observable } from "rxjs/Observable";
import { SessionStorage } from "ngx-webstorage";

@Injectable()
export class AppService {
  constructor(private httpService: HttpService) {}

  logOut(): Observable<any> {
    return this.httpService
      .post(`logout`, "")
      .map((res: Response) => res.json())
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts